/* Pufloo storefront behaviour.
   Runs inside the Shopify theme (uses the AJAX Cart API) and in the static
   preview (falls back to a localStorage mock cart driven by window.FB_PRODUCTS). */
(function () {
  "use strict";

  var FB = window.FB = window.FB || {};
  var cfg = FB.config || {};
  var isShopify = !!cfg.shopify;
  var FREE_SHIP = cfg.freeShippingCents || 9900;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  FB.money = function (cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, "");
    var fmt = cfg.moneyFormat || "${{amount}}";
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  };

  /* ---------- Announcement bar ---------- */
  var annItems = $$(".announcement__item");
  if (annItems.length > 1) {
    var ai = 0;
    setInterval(function () {
      var cur = annItems[ai];
      cur.classList.remove("is-active"); cur.classList.add("is-leaving");
      setTimeout(function () { cur.classList.remove("is-leaving"); }, 500);
      ai = (ai + 1) % annItems.length;
      annItems[ai].classList.add("is-active");
    }, 4200);
  }

  /* ---------- Header shadow ---------- */
  var header = $(".site-header");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 10); };
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  }

  /* ---------- Overlays (mobile nav, cart, modal) ---------- */
  var scrim = $("[data-scrim]");
  var openPanel = null;
  function open(panel) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) close();
    openPanel = panel;
    panel.classList.add("is-open");
    panel.setAttribute("aria-hidden", "false");
    if (scrim && !panel.classList.contains("modal")) scrim.classList.add("is-visible");
    document.body.style.overflow = "hidden";
    var focusable = panel.querySelector("button, a, input");
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function close() {
    if (!openPanel) return;
    openPanel.classList.remove("is-open");
    openPanel.setAttribute("aria-hidden", "true");
    openPanel = null;
    if (scrim) scrim.classList.remove("is-visible");
    document.body.style.overflow = "";
  }
  FB.openPanel = open; FB.closePanel = close;
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-open]");
    if (t) { e.preventDefault(); open(document.getElementById(t.getAttribute("data-open"))); return; }
    if (e.target.closest("[data-close]") || e.target.matches("[data-scrim]")) { e.preventDefault(); close(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  /* ---------- Toast ---------- */
  var toastEl;
  FB.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "toast"; toastEl.setAttribute("role", "status"); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add("is-visible");
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("is-visible"); }, 2600);
  };

  /* ---------- Cart adapters ---------- */
  var Mock = {
    key: "fb-preview-cart",
    load: function () { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    save: function (lines) { try { localStorage.setItem(this.key, JSON.stringify(lines)); } catch (e) {} },
    find: function (handle) { return (window.FB_PRODUCTS || []).filter(function (p) { return p.handle === handle; })[0]; },
    get: function () {
      var lines = this.load(), self = this, subtotal = 0, count = 0;
      var items = lines.map(function (l) {
        var p = self.find(l.handle) || {};
        var unit = l.size.indexOf("Kids") === 0 ? 7900 : 9900;
        subtotal += unit * l.qty; count += l.qty;
        return { key: l.handle + "|" + l.size, title: p.title, variant: l.size, image: p.front, tint: p.tint,
                 url: "product.html?p=" + l.handle, price: unit, line: unit * l.qty, qty: l.qty };
      });
      var discount = count >= 2 ? Math.round(subtotal * 0.15) : 0;
      return Promise.resolve({ items: items, count: count, subtotal: subtotal, discount: discount, total: subtotal - discount });
    },
    add: function (data) {
      var lines = this.load(), size = data.size || "Adult (One Size)";
      var hit = lines.filter(function (l) { return l.handle === data.handle && l.size === size; })[0];
      if (hit) hit.qty += data.qty || 1; else lines.push({ handle: data.handle, size: size, qty: data.qty || 1 });
      this.save(lines); return this.get();
    },
    change: function (key, qty) {
      var parts = key.split("|");
      var lines = this.load().map(function (l) { if (l.handle === parts[0] && l.size === parts[1]) l.qty = qty; return l; })
        .filter(function (l) { return l.qty > 0; });
      this.save(lines); return this.get();
    }
  };

  var Live = {
    // automatic discounts (e.g. "Buy 2, save 15%") show up either cart-level or per line
    discountTitle: function (c) {
      var apps = c.cart_level_discount_applications || [];
      if (apps.length) return apps[0].title;
      for (var i = 0; i < c.items.length; i++) {
        var allocs = c.items[i].line_level_discount_allocations || [];
        if (allocs.length && allocs[0].discount_application) return allocs[0].discount_application.title;
        var lineDiscounts = c.items[i].discounts || [];
        if (lineDiscounts.length && lineDiscounts[0].title) return lineDiscounts[0].title;
      }
      return "";
    },
    normalise: function (c) {
      return {
        count: c.item_count, subtotal: c.original_total_price, discount: c.total_discount, total: c.total_price,
        discountLabel: Live.discountTitle(c),
        items: c.items.map(function (i) {
          return { key: i.key, title: i.product_title, variant: i.variant_title, image: i.image, tint: (i.properties && i.properties._tint) || "",
                   url: i.url, price: i.final_price, line: i.final_line_price, qty: i.quantity };
        })
      };
    },
    req: function (url, body) {
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + url, {
        method: body ? "POST" : "GET",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    get: function () { return this.req("cart.js").then(this.normalise); },
    add: function (data) {
      var self = this;
      return this.req("cart/add.js", { items: [{ id: data.id, quantity: data.qty || 1, properties: data.tint ? { _tint: data.tint } : {} }] })
        .then(function () { return self.get(); });
    },
    change: function (key, qty) { return this.req("cart/change.js", { id: key, quantity: qty }).then(this.normalise); }
  };

  var Cart = isShopify ? Live : Mock;
  FB.cart = Cart;

  var drawer = $("#cart-drawer");
  function renderCart(c) {
    $$(".cart-count").forEach(function (el) { el.textContent = c.count; el.classList.toggle("has-items", c.count > 0); });
    if (!drawer) return;
    var itemsEl = $(".cart-drawer__items", drawer);
    var left = FREE_SHIP - c.total;
    $("[data-ship-msg]", drawer).innerHTML = c.count === 0
      ? "Spend " + FB.money(FREE_SHIP) + " for free shipping 🚚"
      : left > 0 ? "You're <strong>" + FB.money(left) + "</strong> away from free shipping"
                 : "Yay! You've unlocked <strong>free shipping</strong> 🎉";
    $(".ship-progress__bar span", drawer).style.width = Math.min(100, (c.total / FREE_SHIP) * 100) + "%";
    if (!c.items.length) {
      itemsEl.innerHTML = '<div class="cart-empty">' + (FB.icons && FB.icons.hoodie || "") +
        '<h3>Your cart is feeling chilly</h3><p>Let\'s find you something snuggly.</p>' +
        '<a class="btn btn--primary" href="' + (cfg.allUrl || "collection.html") + '">Shop hoodie blankets</a></div>';
    } else {
      itemsEl.innerHTML = c.items.map(function (i) {
        return '<div class="cart-item" data-key="' + i.key + '">' +
          '<a class="cart-item__img" href="' + i.url + '" style="--tint:' + (i.tint || "var(--oat)") + '"><img src="' + i.image + '" alt="" loading="lazy"></a>' +
          '<div><h3><a href="' + i.url + '">' + i.title + '</a></h3><small>' + (i.variant || "") + '</small>' +
          '<div class="qty"><button type="button" data-cart-qty="-1" aria-label="Decrease quantity">−</button>' +
          '<input type="number" value="' + i.qty + '" min="0" aria-label="Quantity" readonly>' +
          '<button type="button" data-cart-qty="1" aria-label="Increase quantity">+</button></div></div>' +
          '<div class="cart-item__price">' + FB.money(i.line) + '<button type="button" class="cart-item__remove" data-cart-remove>Remove</button></div></div>';
      }).join("");
    }
    $("[data-subtotal]", drawer).textContent = FB.money(c.subtotal);
    var disc = $("[data-discount-line]", drawer);
    disc.hidden = !c.discount;
    $("[data-discount]", drawer).textContent = "−" + FB.money(c.discount);
    if (c.discountLabel) $("span", disc).textContent = c.discountLabel;
    $("[data-total]", drawer).textContent = FB.money(c.total);
    $(".cart-drawer__foot", drawer).hidden = !c.items.length;
  }
  FB.refreshCart = function () { return Cart.get().then(renderCart); };
  FB.refreshCart();

  if (drawer) {
    drawer.addEventListener("click", function (e) {
      var row = e.target.closest(".cart-item"); if (!row) return;
      var qtyBtn = e.target.closest("[data-cart-qty]");
      var cur = parseInt($("input", row).value, 10);
      if (qtyBtn) Cart.change(row.dataset.key, Math.max(0, cur + parseInt(qtyBtn.dataset.cartQty, 10))).then(renderCart);
      if (e.target.closest("[data-cart-remove]")) Cart.change(row.dataset.key, 0).then(renderCart);
    });
  }

  function addToCart(data, btn) {
    var label = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.innerHTML = "Adding…"; }
    return Cart.add(data).then(function (c) {
      renderCart(c); open(drawer);
    }).catch(function (err) {
      FB.toast((err && err.description) || "Sorry, that couldn't be added.");
    }).then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  }
  FB.addToCart = addToCart;

  document.addEventListener("click", function (e) {
    var q = e.target.closest("[data-quick-add]");
    if (!q) return;
    e.preventDefault();
    addToCart({ id: q.dataset.variantId, handle: q.dataset.handle, size: "Adult (One Size)", tint: q.dataset.tint, qty: 1 }, q);
  });

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-product-form]");
    if (form) {
      e.preventDefault();
      var fd = new FormData(form);
      addToCart({ id: fd.get("id"), handle: form.dataset.handle, size: fd.get("size"), tint: form.dataset.tint,
                  qty: parseInt(fd.get("quantity"), 10) || 1 }, form.querySelector("[type=submit]"));
      return;
    }
    var nl = e.target.closest("[data-preview-form]");
    if (nl) {
      e.preventDefault();
      var msg = nl.parentNode.querySelector(".form-message");
      if (msg) { msg.hidden = false; }
      nl.reset();
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty-step]"); if (!b) return;
    var input = b.parentNode.querySelector("input");
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
  });

  /* ---------- Product page ---------- */
  FB.initProduct = function (root) {
    root = root || document;
    var main = $(".gallery__main", root);
    if (main) {
      var mainImg = $("img", main);
      var thumbs = $$(".gallery__thumb", root);
      var show = function (i) {
        thumbs.forEach(function (t, j) { t.classList.toggle("is-active", i === j); t.setAttribute("aria-current", i === j); });
        mainImg.style.opacity = 0;
        setTimeout(function () { mainImg.removeAttribute("srcset"); mainImg.removeAttribute("sizes"); mainImg.src = thumbs[i].dataset.src; mainImg.alt = thumbs[i].dataset.alt || ""; mainImg.style.opacity = 1; }, 160);
        main.dataset.index = i;
      };
      thumbs.forEach(function (t, i) { t.addEventListener("click", function () { show(i); }); });
      var flip = $(".gallery__flip", root);
      if (flip) flip.addEventListener("click", function (e) {
        e.stopPropagation();
        show(((parseInt(main.dataset.index, 10) || 0) + 1) % thumbs.length);
      });
      main.addEventListener("click", function (e) {
        if (e.target.closest(".gallery__flip")) return;
        main.classList.toggle("is-zoomed");
        if (!main.classList.contains("is-zoomed")) mainImg.style.transformOrigin = "";
      });
      main.addEventListener("mousemove", function (e) {
        if (!main.classList.contains("is-zoomed")) return;
        var r = main.getBoundingClientRect();
        mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
      });
    }

    // variant (size) selection updates price + hidden variant id
    var form = $("[data-product-form]", root);
    var variantsEl = $("[data-variants]", root);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;
    $$("input[name=size]", root).forEach(function (r) {
      r.addEventListener("change", function () {
        var v = variants ? variants.filter(function (x) { return x.title === r.value; })[0] : null;
        var price = v ? v.price : parseInt(r.dataset.price, 10);
        var compare = v ? v.compare_at_price : parseInt(r.dataset.compare, 10);
        $$("[data-price]", root).forEach(function (el) { el.textContent = FB.money(price); });
        $$("[data-compare]", root).forEach(function (el) { el.textContent = compare > price ? FB.money(compare) : ""; });
        $$("[data-save]", root).forEach(function (el) { el.textContent = compare > price ? "Save " + FB.money(compare - price) : ""; el.hidden = !(compare > price); });
        $$("[data-size-label]", root).forEach(function (el) { el.textContent = r.value; });
        if (v && form) {
          form.querySelector("[name=id]").value = v.id;
          var btn = form.querySelector("[type=submit]");
          btn.disabled = !v.available;
          btn.querySelector("span").textContent = v.available ? (cfg.atcLabel || "Add to cart") : "Sold out";
          if (window.history.replaceState) {
            var u = new URL(window.location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
          }
        }
      });
    });

    // sticky add-to-cart bar
    var sticky = $(".sticky-atc");
    var mainBtn = form && form.querySelector("[type=submit]");
    if (sticky && mainBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle("is-visible", !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(mainBtn);
      $("[data-sticky-atc]", sticky).addEventListener("click", function () { mainBtn.click(); });
    }
  };

  /* ---------- Anatomy hotspots ---------- */
  $$("[data-anatomy]").forEach(function (wrap) {
    var spots = $$(".hotspot", wrap), items = $$(".feature-list li", wrap);
    var set = function (i) {
      spots.forEach(function (s, j) { s.classList.toggle("is-active", i === j); });
      items.forEach(function (s, j) { s.classList.toggle("is-active", i === j); });
    };
    spots.forEach(function (s, i) { s.addEventListener("click", function () { set(i); }); s.addEventListener("mouseenter", function () { set(i); }); });
    items.forEach(function (s, i) { s.addEventListener("click", function () { set(i); }); s.addEventListener("mouseenter", function () { set(i); }); });
    set(0);
  });

  /* ---------- Tabs (Shopify product tabs: one panel per collection) ---------- */
  $$("[data-tabs]").forEach(function (list) {
    var tabs = $$("[role=tab]", list);
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) {
          var on = t === tab, panel = document.getElementById(t.getAttribute("aria-controls"));
          t.classList.toggle("is-active", on); t.setAttribute("aria-selected", on);
          if (panel) { panel.hidden = !on; if (on) $$(".reveal", panel).forEach(function (el) { el.classList.add("is-in"); }); }
        });
      });
    });
  });

  /* ---------- Filter chips (preview homepage + collection page) ---------- */
  $$("[data-filter-group]").forEach(function (group) {
    var target = document.getElementById(group.dataset.filterGroup);
    if (!target) return;
    var countEl = document.querySelector("[data-result-count='" + group.dataset.filterGroup + "']");
    var limit = parseInt(group.dataset.limit || "0", 10);
    var apply = function (val) {
      var shown = 0;
      $$("[data-tags]", target).forEach(function (card) {
        var ok = val === "all" || (" " + card.dataset.tags + " ").indexOf(" " + val + " ") > -1;
        if (ok && limit && shown >= limit) ok = false;
        card.hidden = !ok; if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? " design" : " designs");
    };
    group.addEventListener("click", function (e) {
      var chip = e.target.closest("[data-filter]"); if (!chip) return;
      $$("[data-filter]", group).forEach(function (c) { c.classList.toggle("is-active", c === chip); c.setAttribute("aria-selected", c === chip); });
      apply(chip.dataset.filter);
    });
    var initial = $("[data-filter].is-active", group);
    apply(initial ? initial.dataset.filter : "all");
  });

  // client-side sort on collection pages
  $$("[data-sort]").forEach(function (sel) {
    var grid = document.getElementById(sel.dataset.sort);
    sel.addEventListener("change", function () {
      if (sel.dataset.server === "true") {
        var u = new URL(window.location.href); u.searchParams.set("sort_by", sel.value); window.location = u; return;
      }
      var cards = $$("[data-tags]", grid);
      var key = sel.value;
      cards.sort(function (a, b) {
        if (key === "title-ascending") return a.dataset.title.localeCompare(b.dataset.title);
        if (key === "title-descending") return b.dataset.title.localeCompare(a.dataset.title);
        if (key === "best-selling") return (b.dataset.best || 0) - (a.dataset.best || 0) || a.dataset.index - b.dataset.index;
        return a.dataset.index - b.dataset.index;
      }).forEach(function (c) { grid.appendChild(c); });
    });
  });

  /* ---------- Banner slideshow ---------- */
  $$("[data-slider]").forEach(function (root) {
    var track = $("[data-slider-track]", root), dots = $$("[data-slider-dot]", root);
    var count = track.children.length, delay = parseInt(root.dataset.autoplay, 10) * 1000, timer;
    if (count < 2) return;
    var current = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var go = function (i) { track.scrollTo({ left: ((i + count) % count) * track.clientWidth, behavior: "smooth" }); };
    var mark = function () { var c = current(); dots.forEach(function (d, j) { d.setAttribute("aria-current", j === c ? "true" : "false"); }); };
    var stop = function () { clearInterval(timer); };
    var start = function () { stop(); if (delay > 0 && !matchMedia("(prefers-reduced-motion: reduce)").matches) timer = setInterval(function () { go(current() + 1); }, delay); };
    track.addEventListener("scroll", function () { clearTimeout(track._t); track._t = setTimeout(mark, 80); }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener("click", function () { go(j); start(); }); });
    var prev = $("[data-slider-prev]", root), next = $("[data-slider-next]", root);
    if (prev) prev.addEventListener("click", function () { go(current() - 1); start(); });
    if (next) next.addEventListener("click", function () { go(current() + 1); start(); });
    root.addEventListener("mouseenter", stop); root.addEventListener("mouseleave", start);
    track.addEventListener("touchstart", stop, { passive: true }); track.addEventListener("touchend", start, { passive: true });
    document.addEventListener("visibilitychange", function () { if (document.hidden) stop(); else start(); });
    start();
  });

  /* ---------- Reveal on scroll ---------- */
  FB.observeReveals = function () {
    var els = $$(".reveal:not(.is-in)");
    if (!("IntersectionObserver" in window)) { els.forEach(function (el) { el.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  };
  FB.observeReveals();

  if ($("[data-product-form]")) FB.initProduct();
})();
